import { cn } from 'common/utils';
import React from 'react';

const SimpleSwitch = ({
  onToggle,
  isActive,
  isDisabled = false,
  labelActive = '',
  labelInactive = '',
}) => {
  const toggleSwitch = () => {
    onToggle();
  };

  return (
    <div
      role='switch'
      aria-checked={isActive}
      aria-disabled={isDisabled}
      className={cn(
        'flex items-center cursor-pointer',
        isDisabled && 'cursor-not-allowed opacity-50',
      )}
      onClick={toggleSwitch}
    >
      <div
        className={cn(
          'relative flex items-center justify-center',
          'w-[44px] h-[14px] rounded-full',
          'transition-colors duration-300 ease-in-out',
        )}
        style={{
          position: 'relative',
          backgroundColor: 'transparent',
        }}
      >
        <div
          style={{
            position: 'absolute',
            width: '44px',
            height: '18px',
            backgroundColor: isActive
              ? 'rgba(241, 99, 71, 0.8)'
              : 'rgb(180, 180, 180)',
            borderRadius: '20px',
            opacity: '0.35',
            transition: 'background-color 0.3s ease',
            zIndex: 1,
          }}
        />
        <div
          style={{
            position: 'absolute',
            width: '22px',
            height: '22px',
            backgroundColor: isActive ? '#F16347' : 'rgb(180, 180, 180)',
            borderRadius: '50%',
            top: '50%',
            left: isActive ? 'calc(100% - 22px)' : '0px',
            transform: 'translateY(-50%)',
            transition: 'left 0.3s ease',
            zIndex: 2,
          }}
        />
      </div>
      {(labelActive || labelInactive) && (
        <span className='ml-1 text-sm font-medium'>
          {isActive ? labelActive : labelInactive}
        </span>
      )}
    </div>
  );
};

export default SimpleSwitch;
